import styled from 'styled-components';
import media from '../../../../../constants/media';
import theme from '../../../../../constants/theme';

export const PaginationContainer = styled.nav`
	list-style: none;
	margin-top: 80px;
	padding: 0;
	display: flex;
	justify-content: center;

	ul {
		list-style: none;
		margin: 0;
		padding: 0;
		position: relative;
		display: flex;
		justify-content: center;
		flex: 1;
		li {
			margin-inline: 4px;
			width: 48px;
			height: 48px;
			border-radius: 8px;
			border: 1px solid ${theme.colorsV2.grey5};
			background-color: ${theme.colorsV2.grey1};
			color: ${theme.colorsV2.grey6};
			cursor: pointer;
			display: list-item;
			transition: all 0.2s ease;
			user-select: none;
			a {
				display: flex;
				align-items: center;
				justify-content: center;
				width: 100%;
				height: 100%;
				font-size: 22px;
				svg {
					fill: ${theme.colorsV2.grey6};
				}
			}
			&:hover {
				border: 1px solid ${theme.colorsV2.grey6};
				color: ${theme.colorsV2.grey6};
			}
			&.active {
				border: 2px solid ${theme.colorsV2.mainRed};
				color: ${theme.colorsV2.mainRed};
			}
			&.previous {
				margin-right: auto;
				&.shifted {
					${media.mobileOnly`
                        position: absolute;
                        top: 70px;
                        right: 50%;
                        margin-right: 10px;
                    `};
				}
				svg polygon {
					fill: ${theme.colorsV2.mainRed};
				}
			}
			&.next {
				margin-left: auto;
				margin-right: 0;
				&.shifted {
					${media.mobileOnly`
                        position: absolute;
                        top: 70px;
                        left: 50%;
                        margin-left: 10px;
                    `};
				}
				svg polygon {
					fill: ${theme.colorsV2.mainRed};
				}
			}
			&.break-me a {
				margin-top: 6px;
			}
			&.disabled {
				border: 1px solid ${theme.colorsV2.grey6};
				cursor: default;
				svg polygon {
					fill: ${theme.colorsV2.grey6};
				}
			}
		}
	}
`;
